module.exports = __webpack_public_path__ + "img/01-md.f3d1404.webp";